module.exports = __webpack_public_path__ + "img/news.1b887985.png";